import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { variants, th } from 'style/theme';

const Input = styled.input`
  background-color: transparent;
  border-radius: 0;
  padding-bottom: 3px;
  padding-left: 0;
  font-size: 16px;
  width: 100%;

  ${variants('variant', {
    light: css`
      color: ${th('colors.white')};
      border-bottom: 1px solid ${th('colors.white')};
      ::placeholder {
        color: ${th('colors.white')};
      }
    `,
    dark: css`
      color: ${th('colors.black')};
      border-bottom: 1px solid ${th('colors.black')};
      ::placeholder {
        color: ${th('colors.black')};
      }
    `,
    block: css`
      color: ${th('colors.black')};
      border-bottom: 0px;
      background-color: ${th('colors.white')};
      border-radius: 5px;
      text-indent: 5px;
      padding-top: 6px;
      padding-bottom: 6px;
      margin-top: 5px;
      ::placeholder {
        color: ${th('colors.black')};
      }
    `
  })};

  ${variants('spacing', {
    normal: css`
      margin: 8px 0 0 0;
    `,
    large: css`
      margin: 14px 0 0 0;
    `
  })};

  ::placeholder {
    opacity: 0.5;
    font-style: italic;
  }

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.7;
      border-bottom: none;
    `}
`;

Input.propTypes = {
  variant: PropTypes.oneOf(['block', 'light', 'dark']),
  spacing: PropTypes.oneOf(['normal', 'large'])
};

Input.defaultProps = {
  variant: 'dark',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  autoComplete: 'off',
  spellCheck: 'false',
  spacing: 'normal'
};

export default Input;
